module.exports = __webpack_public_path__ + "static/img/Alchemy Stars.cef6b322.png";